// Lets the Tuner click announce bar downbeats and stops to other tuner tools.
const bars = new Set();
const stops = new Set();

export const clickBus = {
  control: null,
  onBar(fn) { bars.add(fn); return () => bars.delete(fn); },
  emitBar() { bars.forEach((fn) => fn()); },
  onStop(fn) { stops.add(fn); return () => stops.delete(fn); },
  emitStop() { stops.forEach((fn) => fn()); },
};
